/**
* author: duxin
* date: 2020/4/7
* describe:
*/

<template>
    <div class="honour-chunk">
        <p class="p1">{{$t("about.honor")}}</p>
        <div class="content-wrap">
            <div :class="`node ${item.show?'active':''}`" v-for="(item,index) in detailsList"
                 @mouseenter="onMouseenter(index)">
                <div class="line"></div>
                <p class="date">{{item.year}}</p>
                <div class="dot"></div>
                <div class="details-wrap">
                    <ul>
                        <template v-for="v in item.infoList">
                            <li>{{v}}</li>
                        </template>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "honour-chunk",
        data() {
            return {
                detailsList: [
                    {
                        year: 2025,
                        show: true,
                        infoList:this.$t("about.honor2025")
                    },
                    {
                        year: 2024,
                        show: false,
                        infoList:this.$t("about.honor2024")
                    },
                    {
                        year: 2023,
                        show: false,
                        infoList:this.$t("about.honor2023")
                    },
                    {
                        year: 2022,
                        show: false,
                        infoList:this.$t("about.honor2022")
                    },
                    {
                        year: 2021,
                        show: false,
                        infoList:this.$t("about.honor2021")
                    },
                    {
                        year: 2020,
                        show: false,
                        infoList:this.$t("about.honor2020")
                    },
                    {
                        year: 2019,
                        show: false,
                        infoList:this.$t("about.honor2019")
                    },
                    {
                        year: 2018,
                        show: false,
                        infoList: this.$t("about.honor2018")
                    },
                    {
                        year: 2016,
                        show: false,
                        infoList: this.$t("about.honor2016")
                    },
                    {
                        year: 2015,
                        show: false,
                        infoList:this.$t("about.honor2015")
                    },
                    {
                        year: 2014,
                        show: false,
                        infoList: this.$t("about.honor2014")
                    }
                ]
            }
        },
        methods: {
            onMouseenter(index) {
                for (let detail of this.detailsList) {
                    detail.show = false;
                }
                this.detailsList[index].show = true;
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../../style/constant";

    .honour-chunk {
        width: @page-width;
        margin: 0 auto;
        padding: 120px 0 100px;

        .p1 {
            font-size: 32px;
            text-align: center;
            font-weight: 500;
        }

        @media screen and (min-width: 320px) and (max-width: 480px) {

            .p1 {
                font-size: 24px;
            }
        }

        .content-wrap {
            padding-bottom: 50px;
            margin-top: 60px;
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .node {
            position: relative;
            color: @active-color;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;

            .details-wrap {
                position: absolute;
                width: 520px;
                box-shadow: 2px 2px 5px #d2d2d2;
                background-color: white;
                color: @title-color;
                opacity: 0;
                transition: opacity .5s;

                ul {
                    margin: 30px 0;
                    padding-right: 20px;
                }
            }

            .date {
                position: absolute;
                font-size: 20px;
                font-weight: bold;
            }

            &:nth-child(even) {
                .details-wrap {
                    right: 70px;
                }

                .date {
                    left: 20px;
                }
            }

            &:nth-child(odd) {
                .details-wrap {
                    left: 70px;
                }

                .date {
                    right: 20px;
                }
            }

            .line {
                width: 2px;
                height: 50px;
                background-color: #7a7a7a;
                transition: height .5s;
            }

            .dot {
                background-color: rgb(255, 193, 169);
                width: 6px;
                height: 6px;
                left: -7px;
                border-radius: 50%;
                position: absolute;
                border: 5px solid @active-color;
                z-index: 100;
            }
        }

        .active {
            color: #435ba1;

            .dot {
                transform: scale(1.3);
            }

            .line {
                height: 180px;
            }

            .details-wrap {
                opacity: 1;
            }
        }

        .node-enter {
            transform: translateY(10px);
            opacity: 0;
        }

        .node-enter-active {
            transition: transform .3s, opacity .3s;
        }

        .node-leave-active {
            transform: translateY(-20px);
            opacity: 0;
            transition: transform .3s, opacity .3s;
        }
    }

    @media screen and (min-width: 320px) and (max-width: 480px) {
        .honour-chunk {
            width: 90%;
            padding: 50px 0 50px;

            .content-wrap {
                align-items: flex-start;
                padding-left: 60px;
            }

            .node {
                justify-content: flex-start !important;

                .details-wrap {
                    right: auto;
                    left: 20px !important;
                    width: 260px;
                }

                .date {
                    right: auto;
                    left: -60px !important;
                }
            }
        }
    }
</style>
